// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kdmcx","badges":"styles_badges__bE7I7"};